import React, { useCallback, useEffect, useRef, useState } from 'react';

// Styles & Assets
import styles from './MediaDialog.module.css';
import { IoClose } from 'react-icons/io5';
import playSVG from '../../../assets/icons/play.svg';
import videoCamaraIcon from '../../../assets/icons/video-camera.svg';

// Components
import Modal from '../../UI/Modal/Modal';

// Other
import moment from 'moment';

// Interfaces
import { IMessage } from '../../../interfaces/Chat';
interface Props {
    msg: IMessage
    className?: string
}

const MediaDialog: React.FC<Props> = ({ msg, className }) => {

    const [show, setShow] = useState(false);

    const videoRef = useRef<HTMLVideoElement | null>(null);

    const parseDuration = useCallback((duration: number | undefined) => {
        if (duration === undefined) return '00:00';
        let totalSeconds = Math.round(duration);
        const hours = totalSeconds > 3600 ? Math.trunc(totalSeconds / 3600) : 0;
        totalSeconds -= hours * 3600;
        const minutes = totalSeconds > 60 ? Math.trunc(totalSeconds / 60) : 0;
        totalSeconds -= minutes * 60;
        const stringHours = hours > 0 ? (hours > 10 ? hours : '0' + hours) + ':' : '';
        return `${stringHours}${minutes > 10 ? minutes : '0' + minutes}:${totalSeconds > 10 ? totalSeconds : '0' + totalSeconds}`
    }, []);

    const [duration, setDuration] = useState<string | null>(null);

    useEffect(() => {
        const videoElement = videoRef.current;

        if (videoElement) {
            const handleLoadedMetadata = () => {
                setDuration(parseDuration(videoElement.duration));
            };

            videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);

            return () => {
                videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            };
        }
    }, [parseDuration]);



    return (
        <>
            <Modal show={show} setShowModal={setShow}>
                <div className={`dialog ${styles.dialog}`}>
                    <div className={styles.bar}>
                        <h1 className={styles.date}>{moment(msg.timestamp).format('DD-MM-YYYY HH:mm')}</h1>
                        <button className={styles.buttonClose}><IoClose /></button>
                    </div>
                    <div className={styles.imageContainer}>
                        <video controls={true} preload="metadata" width='100%' autoPlay >
                            <source src={msg.dataURL} type="video/mp4" />
                        </video>
                    </div>
                </div>
            </Modal>
            <div className={className ?? styles.videoContainer}>
                <video width='100%' height='100%' controls={false} preload="metadata" ref={videoRef}>
                    <source src={msg.dataURL} type="video/mp4" />
                </video>
                <button className={styles.buttonPlay} onClick={() => setShow(true)}>
                    <img src={playSVG} alt='play video' />
                </button>
                <p className={styles.duration}>
                    <img src={videoCamaraIcon} alt="video camara" />
                    <p>{duration ?? ''}</p>
                </p>
            </div>
        </>
    );
};

export default MediaDialog;